(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["djh-search-modal"] && !Shopify.designMode) return;
  try {
    (function () {
    const modal = document.querySelector('[data-djh-search-modal]');
    const openers = document.querySelectorAll('[data-djh-search-open]');
    if (!modal || !openers.length) return;

    const input = modal.querySelector('[data-djh-search-input]');
    const scopeSelect = modal.querySelector('[data-djh-search-scope]');
    const closers = modal.querySelectorAll('[data-djh-search-close]');
    let lastFocus = null;

    function openModal() {
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.body.classList.add('djh-search-modal-open');
      if (input) {
        input.value = '';
        input.focus();
      }
      if (scopeSelect) scopeSelect.value = '';
    }

    function closeModal() {
      modal.hidden = true;
      document.body.classList.remove('djh-search-modal-open');
      if (lastFocus && typeof lastFocus.focus === 'function') {
        lastFocus.focus();
      }
    }

    openers.forEach((btn) => {
      btn.addEventListener('click', (event) => {
        event.preventDefault();
        openModal();
      });
    });

    closers.forEach((el) => el.addEventListener('click', closeModal));

    /**
     * `aria-modal="true"` IS A PROMISE, AND NOTHING WAS KEEPING IT.
     *
     * This dialog declares role="dialog" and aria-modal="true" (see the markup
     * above), which tells assistive technology that everything outside it is
     * unavailable. A screen reader honouring that hides the page behind — but
     * focus could Tab straight out into it, so the user reached controls their
     * screen reader had just told them were not there. Escape worked and focus
     * was restored correctly; only containment was missing.
     *
     * This is NOT the same call as the mobile nav drawer in header.liquid, which
     * deliberately does not trap. That is a navigation drawer and does not claim
     * to be modal; tabbing past its last link reaching the page is honest there.
     * A dialog that claims aria-modal has to behave like one, or drop the claim.
     *
     * The list is recomputed on every Tab rather than cached at open: the scope
     * select and the close button are always present, but a cached list is how a
     * trap strands someone when the DOM changes underneath it. If nothing is
     * focusable, this does nothing at all and Tab behaves normally — the failure
     * mode is "no trap", never "no way out". Escape and the close button remain.
     */
    function focusableInModal() {
      return Array.prototype.filter.call(
        modal.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'),
        (el) => el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement,
      );
    }

    modal.addEventListener('keydown', (event) => {
      if (event.key !== 'Tab' || modal.hidden) return;
      const items = focusableInModal();
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !modal.hidden) {
        closeModal();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
